import { inject, Injectable } from '@angular/core';
import { from, map, of } from 'rxjs';
import { StateService } from './state.service';

@Injectable({
  providedIn: 'root',
})
export class NetworkInterceptorHelperService {
  private state = inject(StateService);

  public getTenantHeaders(tenantFromContext?: string) {
    if (tenantFromContext === null) return;
    const tenantId =
      tenantFromContext ||
      this.state.visitingTenant$.value?.id ||
      this.state.activeTenant$?.value?.id ||
      this.state.tenants?.[0]?.id;

    if (!tenantId) return;

    return { 'picflow-tenant': tenantId };
  }

  public getGuestHeaders() {
    return from(this.state.renewGuestAuthToken()).pipe(
      map(() => {
        if (!this.state.guestAuthToken) {
          console.warn('guest_token_rm'); // guest token was removed during renewGuestAuthToken
          return of({}); // if token was removed during renewGuestAuthToken
        }
        return {
          authorization: `Bearer ${this.state.guestAuthToken}`,
        };
      })
    );
  }

  public getUserHeaders() {
    return from(this.state.tokenData.getIdToken()).pipe(
      map(token => {
        const headers: { [name: string]: string | string[] } = {
          Authorization: `Bearer ${token}`,
        };
        return headers;
      })
    );
  }
}
